import { Box, Typography, IconButton, Link } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";

export default function Footer() {
    return (
        <Box
            component="footer"
            sx={{
                height: "100px", // altezza fissa
                px: 3,
                py: 1,
                backgroundColor: "#f5f5f5",
                borderTop: "1px solid rgba(0,0,0,0.2)",
                display: "flex",
                flexDirection: "row", // sempre in riga
                alignItems: "center", // centra verticalmente
                justifyContent: "space-between",
                gap: 2,
            }}
        >
            {/* Info a sinistra */}
            <Box sx={{ textAlign: "left" }}>
                <Typography variant="h6" fontWeight="bold" color="#1a1a1a">
                    Giovanna Losco
                </Typography>
                <Typography variant="body2" color="#333333">
                    Artist & Project Manager
                </Typography>
                <Typography variant="body2" color="#333333">
                    P.IVA 02564151203
                </Typography>
            </Box>

            {/* Social a destra */}
            <Box sx={{ display: "flex", gap: 1 }}>
                <IconButton
                    component={Link}
                    href="https://www.facebook.com/p/Giovanna-Losco-Artist-Project-manager-100057312647010/"
                    target="_blank"
                    rel="noopener"
                    color="inherit"
                    sx={{
                        transition: "all 0.3s",
                        "&:hover": { color: "#3b5998" },
                    }}
                >
                    <FacebookIcon />
                </IconButton>
                <IconButton
                    component={Link}
                    href="https://www.instagram.com/giovannalosco/#"
                    target="_blank"
                    rel="noopener"
                    color="inherit"
                    sx={{
                        transition: "all 0.3s",
                        "&:hover": { color: "#e1306c" },
                    }}
                >
                    <InstagramIcon />
                </IconButton>
            </Box>
        </Box>
    );
}